/** Default COLAB copilot (ARI) — IDs match TemporaryChatContext. */
export const DEFAULT_COPILOT = {
  label: 'ARI',
  value: '0024fb7d-898b-4179-bc87-17c0cd82c081',
  icon: 'https://feedalabs-agent-icon.s3.eu-north-1.amazonaws.com/ARI_116c19cc91184f439c11867f41971a35.jpg',
  mode: 'agent',
};

export const DEFAULT_COPILOT_ID = DEFAULT_COPILOT.value;
export const DEFAULT_COPILOT_NAME = DEFAULT_COPILOT.label;
export const DEFAULT_COPILOT_ICON = DEFAULT_COPILOT.icon;

export function isDefaultCopilot(agent) {
  if (!agent) return false;
  const id = agent.value ?? agent.id ?? agent.agent_id;
  const name = (agent.label || agent.agent_name || '').toLowerCase().trim();
  return (
    String(id) === DEFAULT_COPILOT_ID ||
    String(id) === '6d1cd244-2e8e-4782-981d-24cae676f7c7' ||
    name === 'ari' ||
    name === 'ferdy'
  );
}

export function findDefaultCopilot(agents) {
  if (!agents?.length) return null;
  return (
    agents.find(a => isDefaultCopilot(a)) ||
    null
  );
}

/** Map an API agent to a select/context option; brand the default as ARI. */
export function toDefaultAwareAgentOption(agent) {
  if (!agent) return null;
  const value = agent.id ?? agent.agent_id ?? agent.value;
  if (isDefaultCopilot(agent) || String(value) === DEFAULT_COPILOT_ID) {
    return {
      label: DEFAULT_COPILOT_NAME,
      value: DEFAULT_COPILOT_ID,
      icon: DEFAULT_COPILOT_ICON,
      mode: 'agent',
    };
  }
  return {
    label: agent.agent_name || agent.label,
    value,
    icon: agent.icon ?? null,
    mode: agent.mode || 'agent',
  };
}
